// URL search params of the Production BOMs page (PX-ENG-130). Kept apart from
// the page module so the route config (entry chunk) does not pull the page in.
import { pbomListColumns } from "@patronix/domain/list";
import { viewSearch, type ViewSearch } from "@/lib/listView";
import { pbomFilters, type PbomFilter } from "./api";

export interface PbomSearch extends ViewSearch {
  status: PbomFilter;
  q: string;
  id?: string | undefined;
  /** The import panel is open (replaces the detail). */
  import?: true | undefined;
}

export function validatePbomSearch(raw: Record<string, unknown>): PbomSearch {
  const s: PbomSearch = {
    status: pbomFilters.includes(raw.status as PbomFilter) ? (raw.status as PbomFilter) : "current",
    q: typeof raw.q === "string" ? raw.q.slice(0, 100) : "",
  };
  if (typeof raw.id === "string" && raw.id) s.id = raw.id;
  if (raw.import === true || raw.import === "true") s.import = true;
  return { ...s, ...viewSearch(pbomListColumns, raw) };
}
